export const getDifferenceArray = (allArray: string[], subArray: string[]) => {
  return allArray.filter((x) => !subArray.includes(x));
};
